import { render, staticRenderFns } from "./ListTeamsRating.vue?vue&type=template&id=bd0c9edc&scoped=true"
import script from "./ListTeamsRating.vue?vue&type=script&lang=js"
export * from "./ListTeamsRating.vue?vue&type=script&lang=js"
import style0 from "./ListTeamsRating.vue?vue&type=style&index=0&id=bd0c9edc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0c9edc",
  null
  
)

export default component.exports